<h2 *ngIf="bodyOrder">
    <strong>Ejecución Mantenimiento para: {{ bodyOrder.code }} </strong>
  </h2>
  <h3 *ngIf="bodyOrder">Número de orden: {{ bodyOrder.consecutive }}</h3>
  <h3 *ngIf="bodyOrder">Tipo de Mantenimiento: {{ bodyOrder.maintenanceType }}</h3>
  <h3 *ngIf="bodyOrder">Responsable: {{ bodyOrder.responsible }}</h3>
  <h3 *ngIf="bodyOrder">Descripción: {{ bodyOrder.description }}</h3>
  <h3 *ngIf="bodyOrder">Fecha ejecución: {{ bodyOrder.executionDate }}</h3>
  <h3 *ngIf="bodyOrder && !inventoryModule">Recursos: {{ bodyOrder.resources }}</h3>
  <h3 *ngIf="bodyOrder">Costo Mantenimiento: {{ bodyOrder.cost | number : "1.0-0" }}</h3>
  <h3><strong>Quién realiza el mantenimiento</strong></h3>
  <div *ngFor="let item of bodyUsuarios">
    <h3>Encargado: {{ item.name }}</h3>
  </div>

  <form
  [formGroup]="formEjecucionOT"
  (ngSubmit)="
    formEjecucionOT.valid
      ? ejecutarOT(formEjecucionOT.value)
      : errorMessage()
  "
>
  <div class="first-row">
    <div class="row-item">
      <mat-form-field>
        <input
          autocomplete="off"
          type="number"
          matInput
          formControlName="finalTime"
          required
          #tiempo
          oninput="this.value = this.value.slice(0,2)"
          placeholder="Tiempo Final horas"
        />
        <mat-hint>{{ tiempo.value.length }}/2</mat-hint>
      </mat-form-field>
    </div>
  </div>

  <div class="default-row" *ngIf="roleId != operatorId">
    <div class="row-item">
      <mat-form-field>
        <input
          autocomplete="off"
          type="number"
          matInput
          formControlName="finalCost"
          required
          #costo
          oninput="this.value = this.value.slice(0,10)"
          placeholder="Costo Final"
        />
        <mat-hint>{{ costo.value.length }}/10</mat-hint>
      </mat-form-field>
    </div>
  </div>
  <div class="default-row">
    <div class="row-item">
      <mat-form-field>
        <input
          autocomplete="off"
          type="text"
          matInput
          formControlName="observations"
          placeholder="Observaciones"
          #observaciones
          maxlength="255"
        />
        <mat-hint>{{ observaciones.value.length }}/255</mat-hint>
      </mat-form-field>
    </div>
  </div>

  <div class="default-row" *ngIf="roleId == operatorId || istraccarDevice">
    <div class="row-item">
      <mat-form-field>
        <input
          autocomplete="off"
          type="number"
          matInput
          formControlName="odometer"
          #odometro
          oninput="this.value = this.value.slice(0,8)"
          placeholder="Odómetro/Horómetro"
          required
        />
        <mat-hint>{{  odometro.value.length }}/8</mat-hint>
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
    </div>
  </div>

  <h3 style="margin: 10px">Adjuntar foto si es necesario</h3>

  <div class="containerPhotos">
    <div class="photo">
      <h3 style="padding: 0; margin: 0; text-align: center">Foto 1</h3>
      <file-input
        [params]="fileInput"
        (fileSave)="fileSave($event, 1)"
      ></file-input>
    </div>
    <div class="photo">
      <h3 style="padding: 0; margin: 0; text-align: center">Foto 2</h3>
      <file-input
        [params]="fileInput"
        (fileSave)="fileSave($event, 2)"
      ></file-input>
    </div>
    <div class="photo">
      <h3 style="padding: 0; margin: 0; text-align: center">Foto 3</h3>
      <file-input
        [params]="fileInput"
        (fileSave)="fileSave($event, 3)"
      ></file-input>
    </div>
  </div>

  <div
    style="
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-top: 30px;
    "
  >
    <button
      [disabled]="buttonActive"
      style="width: 60%"
      color="warn"
      class="button-save mat-elevation-z5"
      type="submit"
      mat-raised-button
    >
      Finalizar
    </button>
  </div>
</form>